export class Options {
    key: string;
    value: boolean;    
}

export class Customization {
    key: string;
    value: string;
}

export class Cible {
    key: number;
    value: string;
    crecheIds: string;
    creneaux: CreneauOuverture[];
    selected: boolean;
}

export class CreneauOuverture {
    jour: number;
    debut: string;
    fin: string;
}

export class Context {
    sending: boolean;
    primaryColor: string;
    accentColor: string;
    bgColor: string;
    test: boolean;
    apiRoot: string;
    logo: string;    
    singlePage: boolean;
    sections: string[];
    monoCible: boolean;

    cibles: Cible[];
    textes: Customization[];
    options: Options[]

    urlRedirection: string;

    constructor() {
        this.logo = null;
        this.singlePage = false;
        this.primaryColor = null;
        this.accentColor = null;
        this.bgColor = null;
        this.sending = false;
        this.sections = ["enfant", "parent-1", "parent-2", "demande", "planning", "complements", "finalisation"];
        this.cibles = [];
        this.textes = [];
        this.options = [];
        this.urlRedirection = null;
    }

    getText(key: string, defaultValue: string = ''): string {
        const pair = this.textes.find(p => p.key === key);
        if (pair) return pair.value;
        return defaultValue;
    }

    hasText(key: string): boolean {
        const pair = this.textes.find(p => p.key === key);
        if (pair) return true;
        return false;
    }

    getOption(key: string): boolean {
        const pair = this.options.find(p => p.key === key);
        if (pair) return pair.value;
        return false;
    }
}